// extracted by mini-css-extract-plugin
export default {"Row":"Row--qJ7X1"};